import axios from "axios";
import { storageApi } from "../storage/storageApi";
import { useState } from "react";
import { lowerFirst } from "lodash/string";

export const useFileDownloader = () => {
  const [downloadList, setLoadingList] = useState([]);

  const download = ({ url }) => {
    const filename = url.split("/").pop();

    setLoadingList((c) => {
      c.push(url);
      return c;
    });
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: {
        authorization: `Bearer ${storageApi.getUserToken()}`,
      },
    })
      .then((response) => {
        console.log("RRRRRRRRRRRRRRRR", response.data);
        const href = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
      .finally(() => {
        setTimeout(() => {
          setLoadingList((c) => {
            return c.filter((x) => x !== url);
          });
        }, 4000);
      });
  };

  return {
    download,
    isLoading: (file) => {
      return !!downloadList.find((c) => c.includes(file));
    },
  };
};
